import type { Geometry, Position } from 'geojson';

function collectPositions(coordinates: unknown, positions: Position[]) {
  if (!Array.isArray(coordinates)) {
    return;
  }

  if (
    coordinates.length >= 2 &&
    typeof coordinates[0] === 'number' &&
    typeof coordinates[1] === 'number'
  ) {
    positions.push(coordinates as Position);
    return;
  }

  coordinates.forEach((coordinate) => collectPositions(coordinate, positions));
}

export function getFieldSessionTrackBounds(
  track?: Geometry | null
): [[number, number], [number, number]] | null {
  if (!track || track.type === 'GeometryCollection') {
    return null;
  }

  const positions: Position[] = [];
  collectPositions(track.coordinates, positions);

  if (positions.length === 0) {
    return null;
  }

  let west = positions[0][0];
  let east = positions[0][0];
  let south = positions[0][1];
  let north = positions[0][1];

  positions.forEach(([longitude, latitude]) => {
    west = Math.min(west, longitude);
    east = Math.max(east, longitude);
    south = Math.min(south, latitude);
    north = Math.max(north, latitude);
  });

  return [
    [west, south],
    [east, north],
  ];
}
